import _defineProperty from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, createEvent, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
import { d as clamp } from './helpers.js';
import { b as hapticSelectionChanged, h as hapticSelectionEnd, a as hapticSelectionStart } from './haptic.js';
var pickerColumnIosCss = ".picker-col{display:-ms-flexbox;display:flex;position:relative;-ms-flex:1;flex:1;-ms-flex-pack:center;justify-content:center;height:100%;-webkit-box-sizing:content-box;box-sizing:content-box;contain:content}.picker-opts{position:relative;-ms-flex:1;flex:1;max-width:100%}.picker-opt{left:0;top:0;display:block;position:absolute;width:100%;border:0;text-align:center;text-overflow:ellipsis;white-space:nowrap;contain:strict;overflow:hidden;will-change:transform}[dir=rtl] .picker-opt,:host-context([dir=rtl]) .picker-opt{left:unset;right:unset;right:0}.picker-opt.picker-opt-disabled{pointer-events:none}.picker-opt-disabled{opacity:0}.picker-opts-left{-ms-flex-pack:start;justify-content:flex-start}.picker-opts-right{-ms-flex-pack:end;justify-content:flex-end}.picker-opt:active,.picker-opt:focus{outline:none}.picker-prefix{position:relative;-ms-flex:1;flex:1;text-align:end;white-space:nowrap}.picker-suffix{position:relative;-ms-flex:1;flex:1;text-align:start;white-space:nowrap}.picker-col{padding-left:4px;padding-right:4px;padding-top:0;padding-bottom:0;-webkit-transform-style:preserve-3d;transform-style:preserve-3d}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.picker-col{padding-left:unset;padding-right:unset;-webkit-padding-start:4px;padding-inline-start:4px;-webkit-padding-end:4px;padding-inline-end:4px}}.picker-prefix,.picker-suffix,.picker-opts{top:77px;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;color:inherit;font-size:20px;line-height:42px;pointer-events:none}.picker-opt{padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-transform-origin:center center;transform-origin:center center;height:46px;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out;background:transparent;color:inherit;font-size:20px;line-height:42px;-webkit-backface-visibility:hidden;backface-visibility:hidden;pointer-events:auto}[dir=rtl] .picker-opt,:host-context([dir=rtl]) .picker-opt{-webkit-transform-origin:calc(100% - center) center;transform-origin:calc(100% - center) center}";
var pickerColumnMdCss = ".picker-col{display:-ms-flexbox;display:flex;position:relative;-ms-flex:1;flex:1;-ms-flex-pack:center;justify-content:center;height:100%;-webkit-box-sizing:content-box;box-sizing:content-box;contain:content}.picker-opts{position:relative;-ms-flex:1;flex:1;max-width:100%}.picker-opt{left:0;top:0;display:block;position:absolute;width:100%;border:0;text-align:center;text-overflow:ellipsis;white-space:nowrap;contain:strict;overflow:hidden;will-change:transform}[dir=rtl] .picker-opt,:host-context([dir=rtl]) .picker-opt{left:unset;right:unset;right:0}.picker-opt.picker-opt-disabled{pointer-events:none}.picker-opt-disabled{opacity:0}.picker-opts-left{-ms-flex-pack:start;justify-content:flex-start}.picker-opts-right{-ms-flex-pack:end;justify-content:flex-end}.picker-opt:active,.picker-opt:focus{outline:none}.picker-prefix{position:relative;-ms-flex:1;flex:1;text-align:end;white-space:nowrap}.picker-suffix{position:relative;-ms-flex:1;flex:1;text-align:start;white-space:nowrap}.picker-col{padding-left:8px;padding-right:8px;padding-top:0;padding-bottom:0;-webkit-transform-style:preserve-3d;transform-style:preserve-3d}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.picker-col{padding-left:unset;padding-right:unset;-webkit-padding-start:8px;padding-inline-start:8px;-webkit-padding-end:8px;padding-inline-end:8px}}.picker-prefix,.picker-suffix,.picker-opts{top:77px;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;color:inherit;font-size:22px;line-height:42px;pointer-events:none}.picker-opt{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;height:43px;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out;background:transparent;color:inherit;font-size:22px;line-height:42px;-webkit-backface-visibility:hidden;backface-visibility:hidden;pointer-events:auto}.picker-prefix,.picker-suffix,.picker-opt.picker-opt-selected{color:var(--ion-color-primary, #3880ff)}";

var PickerColumnCmp = /*#__PURE__*/function (_HTMLElement) {
  _inherits(PickerColumnCmp, _HTMLElement);

  var _super = _createSuper(PickerColumnCmp);

  function PickerColumnCmp() {
    var _this;

    _classCallCheck(this, PickerColumnCmp);

    _this = _super.call(this);

    _this.__registerHost();

    _this.ionPickerColChange = createEvent(_assertThisInitialized(_this), "ionPickerColChange", 7);
    _this.optHeight = 0;
    _this.rotateFactor = 0;
    _this.scaleFactor = 1;
    _this.velocity = 0;
    _this.y = 0;
    _this.noAnimate = true;
    return _this;
  }

  _createClass(PickerColumnCmp, [{
    key: "colChanged",
    value: function colChanged() {
      this.refresh();
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var pickerRotateFactor, pickerScaleFactor, mode;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pickerRotateFactor = 0;
                pickerScaleFactor = 0.81;
                mode = getIonMode(this);

                if (mode === 'ios') {
                  pickerRotateFactor = -0.46;
                  pickerScaleFactor = 1;
                }

                this.rotateFactor = pickerRotateFactor;
                this.scaleFactor = pickerScaleFactor;
                _context.next = 8;
                return import('./index2.js');

              case 8:
                this.gesture = _context.sent.createGesture({
                  el: this.el,
                  gestureName: 'picker-swipe',
                  gesturePriority: 100,
                  threshold: 0,
                  passive: false,
                  onStart: function onStart(ev) {
                    return _this2.onStart(ev);
                  },
                  onMove: function onMove(ev) {
                    return _this2.onMove(ev);
                  },
                  onEnd: function onEnd(ev) {
                    return _this2.onEnd(ev);
                  }
                });
                this.gesture.enable();
                this.tmrId = setTimeout(function () {
                  _this2.noAnimate = false;

                  _this2.refresh(true);
                }, 250);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "componentDidLoad",
    value: function componentDidLoad() {
      var colEl = this.optsEl;

      if (colEl) {
        // DOM READ
        // We perfom a DOM read over a rendered item, this needs to happen after the first render
        this.optHeight = colEl.firstElementChild ? colEl.firstElementChild.clientHeight : 0;
      }

      this.refresh();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      cancelAnimationFrame(this.rafId);
      clearTimeout(this.tmrId);

      if (this.gesture) {
        this.gesture.destroy();
        this.gesture = undefined;
      }
    }
  }, {
    key: "emitColChange",
    value: function emitColChange() {
      this.ionPickerColChange.emit(this.col);
    }
  }, {
    key: "setSelected",
    value: function setSelected(selectedIndex, duration) {
      // if there is a selected index, then figure out it's y position
      // if there isn't a selected index, then just use the top y position
      var y = selectedIndex > -1 ? -(selectedIndex * this.optHeight) : 0;
      this.velocity = 0; // set what y position we're at

      cancelAnimationFrame(this.rafId);
      this.update(y, duration, true);
      this.emitColChange();
    }
  }, {
    key: "update",
    value: function update(y, duration, saveY) {
      if (!this.optsEl) {
        return;
      } // ensure we've got a good round number :)


      var translateY = 0;
      var translateZ = 0;
      var col = this.col,
          rotateFactor = this.rotateFactor;
      var selectedIndex = col.selectedIndex = this.indexForY(-y);
      var durationStr = duration === 0 ? '' : duration + 'ms';
      var scaleStr = "scale(".concat(this.scaleFactor, ")");
      var children = this.optsEl.children;

      for (var i = 0; i < children.length; i++) {
        var button = children[i];
        var opt = col.options[i];
        var optOffset = i * this.optHeight + y;
        var transform = '';

        if (rotateFactor !== 0) {
          var rotateX = optOffset * rotateFactor;

          if (Math.abs(rotateX) <= 90) {
            translateY = 0;
            translateZ = 90;
            transform = "rotateX(".concat(rotateX, "deg) ");
          } else {
            translateY = -9999;
          }
        } else {
          translateZ = 0;
          translateY = optOffset;
        }

        var selected = selectedIndex === i;
        transform += "translate3d(0px,".concat(translateY, "px,").concat(translateZ, "px) ");

        if (this.scaleFactor !== 1 && !selected) {
          transform += scaleStr;
        } // Update transition duration


        if (this.noAnimate) {
          opt.duration = 0;
          button.style.transitionDuration = '';
        } else if (duration !== opt.duration) {
          opt.duration = duration;
          button.style.transitionDuration = durationStr;
        } // Update transform


        if (transform !== opt.transform) {
          opt.transform = transform;
          button.style.transform = transform;
        } // Update selected item


        if (selected !== opt.selected) {
          opt.selected = selected;

          if (selected) {
            button.classList.add(PICKER_OPT_SELECTED);
          } else {
            button.classList.remove(PICKER_OPT_SELECTED);
          }
        }
      }

      this.col.prevSelected = selectedIndex;

      if (saveY) {
        this.y = y;
      }

      if (this.lastIndex !== selectedIndex) {
        // have not set a last index yet
        hapticSelectionChanged();
        this.lastIndex = selectedIndex;
      }
    }
  }, {
    key: "decelerate",
    value: function decelerate() {
      var _this3 = this;

      if (this.velocity !== 0) {
        // still decelerating
        this.velocity *= DECELERATION_FRICTION; // do not let it go slower than a velocity of 1

        this.velocity = this.velocity > 0 ? Math.max(this.velocity, 1) : Math.min(this.velocity, -1);
        var y = this.y + this.velocity;

        if (y > this.minY) {
          // whoops, it's trying to scroll up farther than the options we have!
          y = this.minY;
          this.velocity = 0;
        } else if (y < this.maxY) {
          // gahh, it's trying to scroll down farther than we can!
          y = this.maxY;
          this.velocity = 0;
        }

        this.update(y, 0, true);
        var notLockedIn = Math.round(y) % this.optHeight !== 0 || Math.abs(this.velocity) > 1;

        if (notLockedIn) {
          // isn't locked in yet, keep decelerating until it is
          this.rafId = requestAnimationFrame(function () {
            return _this3.decelerate();
          });
        } else {
          this.velocity = 0;
          this.emitColChange();
          hapticSelectionEnd();
        }
      } else if (this.y % this.optHeight !== 0) {
        // needs to still get locked into a position so options line up
        var currentPos = Math.abs(this.y % this.optHeight); // create a velocity in the direction it needs to scroll

        this.velocity = currentPos > this.optHeight / 2 ? 1 : -1;
        this.decelerate();
      }
    }
  }, {
    key: "indexForY",
    value: function indexForY(y) {
      return Math.min(Math.max(Math.abs(Math.round(y / this.optHeight)), 0), this.col.options.length - 1);
    } // TODO should this check disabled?

  }, {
    key: "onStart",
    value: function onStart(detail) {
      // We have to prevent default in order to block scrolling under the picker
      // but we DO NOT have to stop propagation, since we still want
      // some "click" events to capture
      if (detail.event.cancelable) {
        detail.event.preventDefault();
      }

      detail.event.stopPropagation();
      hapticSelectionStart(); // reset everything

      cancelAnimationFrame(this.rafId);
      var options = this.col.options;
      var minY = options.length - 1;
      var maxY = 0;

      for (var i = 0; i < options.length; i++) {
        if (!options[i].disabled) {
          minY = Math.min(minY, i);
          maxY = Math.max(maxY, i);
        }
      }

      this.minY = -(minY * this.optHeight);
      this.maxY = -(maxY * this.optHeight);
    }
  }, {
    key: "onMove",
    value: function onMove(detail) {
      if (detail.event.cancelable) {
        detail.event.preventDefault();
      }

      detail.event.stopPropagation(); // update the scroll position relative to pointer start position

      var y = this.y + detail.deltaY;

      if (y > this.minY) {
        // scrolling up higher than scroll area
        y = Math.pow(y, 0.8);
        this.bounceFrom = y;
      } else if (y < this.maxY) {
        // scrolling down below scroll area
        y += Math.pow(this.maxY - y, 0.9);
        this.bounceFrom = y;
      } else {
        this.bounceFrom = 0;
      }

      this.update(y, 0, false);
    }
  }, {
    key: "onEnd",
    value: function onEnd(detail) {
      if (this.bounceFrom > 0) {
        // bounce back up
        this.update(this.minY, 100, true);
        this.emitColChange();
        return;
      } else if (this.bounceFrom < 0) {
        // bounce back down
        this.update(this.maxY, 100, true);
        this.emitColChange();
        return;
      }

      this.velocity = clamp(-MAX_PICKER_SPEED, detail.velocityY * 23, MAX_PICKER_SPEED);

      if (this.velocity === 0 && detail.deltaY === 0) {
        var opt = detail.event.target.closest('.picker-opt');

        if (opt && opt.hasAttribute('opt-index')) {
          this.setSelected(parseInt(opt.getAttribute('opt-index'), 10), TRANSITION_DURATION);
        }
      } else {
        this.y += detail.deltaY;

        if (Math.abs(detail.velocityY) < 0.05) {
          var isScrollingUp = detail.deltaY > 0;
          var optHeightFraction = Math.abs(this.y) % this.optHeight / this.optHeight;

          if (isScrollingUp && optHeightFraction > 0.5) {
            this.velocity = Math.abs(this.velocity) * -1;
          } else if (!isScrollingUp && optHeightFraction <= 0.5) {
            this.velocity = Math.abs(this.velocity);
          }
        }

        this.decelerate();
      }
    }
  }, {
    key: "refresh",
    value: function refresh(forceRefresh) {
      var min = this.col.options.length - 1;
      var max = 0;
      var options = this.col.options;

      for (var i = 0; i < options.length; i++) {
        if (!options[i].disabled) {
          min = Math.min(min, i);
          max = Math.max(max, i);
        }
      }
      /**
       * Only update selected value if column has a
       * velocity of 0. If it does not, then the
       * column is animating might land on
       * a value different than the value at
       * selectedIndex
       */


      if (this.velocity !== 0) {
        return;
      }

      var selectedIndex = clamp(min, this.col.selectedIndex || 0, max);

      if (this.col.prevSelected !== selectedIndex || forceRefresh) {
        var y = selectedIndex * this.optHeight * -1;
        this.velocity = 0;
        this.update(y, TRANSITION_DURATION, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _class,
          _this4 = this;

      var col = this.col;
      var Button = 'button';
      var mode = getIonMode(this);
      return h(Host, {
        class: (_class = {}, _defineProperty(_class, mode, true), _defineProperty(_class, 'picker-col', true), _defineProperty(_class, 'picker-opts-left', this.col.align === 'left'), _defineProperty(_class, 'picker-opts-right', this.col.align === 'right'), _class),
        style: {
          'max-width': this.col.columnWidth
        }
      }, col.prefix && h("div", {
        class: "picker-prefix",
        style: {
          width: col.prefixWidth
        }
      }, col.prefix), h("div", {
        class: "picker-opts",
        style: {
          maxWidth: col.optionsWidth
        },
        ref: function ref(el) {
          return _this4.optsEl = el;
        }
      }, col.options.map(function (o, index) {
        return h(Button, {
          type: "button",
          class: {
            'picker-opt': true,
            'picker-opt-disabled': !!o.disabled
          },
          "opt-index": index
        }, o.text);
      })), col.suffix && h("div", {
        class: "picker-suffix",
        style: {
          width: col.suffixWidth
        }
      }, col.suffix));
    }
  }, {
    key: "el",
    get: function get() {
      return this;
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "col": ["colChanged"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return {
        ios: pickerColumnIosCss,
        md: pickerColumnMdCss
      };
    }
  }]);

  return PickerColumnCmp;
}(HTMLElement);

var PICKER_OPT_SELECTED = 'picker-opt-selected';
var DECELERATION_FRICTION = 0.97;
var MAX_PICKER_SPEED = 90;
var TRANSITION_DURATION = 150;
PickerColumnCmp = /*@__PURE__*/proxyCustomElement(PickerColumnCmp, [32, "ion-picker-column", {
  "col": [16]
}]);

function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-picker-column"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-picker-column":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, PickerColumnCmp);
        }

        break;
    }
  });
}

export { PickerColumnCmp as P, defineCustomElement as d };